import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { blue, green, grey, orange, red, unityBlue, unityGreen, unityGrey, unityOrange, unityRed } from './colors';
import { action } from './action';
import { background } from './background';
import { error } from './error';
import { greyOption } from './grey';
import { primary } from './primary';
import { secondary } from './secondary';
import { text } from './text';
import { warning } from './warning';
import { info } from './info';
import { success } from './success';
import { status } from './status';
import { border } from './border';
import { illustration } from './illustration';

/**
 * Returns the MUI PaletteOptions for the given mode.
 */
export function getPaletteOptions(mode: PaletteMode, opts: GetThemeOptions): PaletteOptions {
  // Palette options should be split out into their own files with functions
  // for creating the option values based on light/dark mode
  return {
    mode,
    primary: primary(mode, opts),
    secondary: secondary(mode, opts),
    grey: greyOption(mode, opts),
    background: background(mode, opts),
    action: action(mode, opts),
    text: text(mode, opts),
    error: error(mode, opts),
    warning: warning(mode, opts),
    info: info(mode, opts),
    success: success(mode, opts),

    // Custom colors
    designSystem: opts.panwRebrandStubYear
      ? {
          blue: unityBlue,
          green: unityGreen,
          grey: unityGrey,
          orange: unityOrange,
          red: unityRed,
        }
      : {
          blue,
          green,
          grey,
          orange,
          red,
        },
    status: status(mode, opts),
    border: border(mode, opts),
    illustration: illustration(mode, opts),

    // A contrast threshold of 4.5:1 is required to meet AA
    // https://mui.com/material-ui/customization/palette/#accessibility
    contrastThreshold: 4.5,
  };
}
